import { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';

function getLayerName(sourceKey, layerKey) {
  return `${sourceKey}›${layerKey}`;
}
function usePrevious(value, initialValue) {
  const ref = useRef(initialValue);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
function setMapboxToken(token) {
  mapboxgl.accessToken = token;
}

export { getLayerName, setMapboxToken, usePrevious };
//# sourceMappingURL=utils.js.map
